import { Dispatch } from 'redux'

export type TokenType = 'public' | 'private' | undefined

export type AuthData = {
  expiration_date: number
  token: string
  tokenType: TokenType
  logoutStatus?: 'logged_in' | 'logged_out' | 'logging_out'
}

export type Response = { success: boolean; data?: AuthData }

export const loginSucceeded = (email: string, data: AuthData) => {
  return {
    type: 'login/SUCCEEDED',
    data: {
      username: email,
      expiration_date: data.expiration_date,
      token: data.token,
      tokenType: data.tokenType,
      logoutStatus: 'logged_in'
    }
  }
}

export const loginFailed = () => {
  return {
    type: 'login/FAILED'
  }
}

export const systemReload = () => (dispatch: Dispatch<{ type: string }>) => {
  dispatch({ type: 'redux_store/CLEAR' })
}

/**
 * Reducer
 */
export default function authentication(
  state = {},
  action: { type: string; data?: AuthData }
) {
  switch (action.type) {
    case 'login/SUCCEEDED':
      return action.data
    case 'login/FAILED':
      return {
        logoutStatus: 'logged_out'
      }
    case 'login/TOKEN_EXPIRED':
      return {
        logoutStatus: 'logged_out'
      }
    case 'login/LOGOUT_REQUEST':
      console.log('reducer: logging out')
      return { logoutStatus: 'logging_out' }
    case 'login/LOGOUT':
      return {
        logoutStatus: 'logged_out'
      }
    default:
      return state
  }
}
